import {useContext} from "react";
import {TelephoneSocketContext} from "../context/TelephoneSocketContext";

export const useTelephoneSocket = () => {
  return useContext(TelephoneSocketContext)
}